export default import.meta.ROLLDOWN_FILE_URL_ipnljyPtpVK1lo_JJlwftw